<template>
    <div class="space-y-6 px-3 sm:px-6 lg:col-span-full lg:px-0">
        <template v-if="!gallery">
            <div class="relative sm:border-b border-gray-200">
                <div class="mt-4">
                    <!-- Mobile tabs skeleton -->
                    <div class="grid grid-cols-1 sm:hidden space-y-2">
                        <div class="skeleton h-6 w-1/2 rounded"></div>
                        <div class="skeleton h-6 w-1/3 rounded"></div>
                        <div class="skeleton h-6 w-1/4 rounded"></div>
                        <div class="skeleton h-6 w-1/3 rounded"></div>
                    </div>

                    <!-- Desktop tabs skeleton -->
                    <div class="hidden sm:block">
                        <div class="flex space-x-4 mb-2 overflow-x-auto lg:overflow-x-hidden">
                            <div class="skeleton h-6 w-20 rounded"></div>
                            <div class="skeleton h-6 w-20 rounded"></div>
                            <div class="skeleton h-6 w-20 rounded"></div>
                            <div class="skeleton h-6 w-20 rounded"></div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <ShareGalleryModalComponent
            v-if="gallery && gallery.public_url"
            :open="showShareModal"
            :url="gallery.public_url"
            :qr-url="publicUrl(`qr-code/share?size=500&url=${gallery.public_url}`)"
            :name="gallery.name"
            @close="showShareModal = false"
        />

        <div class="relative sm:border-b border-gray-200" v-if="gallery">
            <div class="mt-4">
                <div class="grid grid-cols-1 sm:hidden">
                    <nav class="flex flex-1 flex-col">
                        <ul role="list" class="-mx-2 space-y-1">
                            <li v-for="tab in tabs" :key="tab.name">
                                <router-link v-if="!tab.external" :to="tab.href" :class="[tab.current ? 'bg-gray-50 outline-1 outline-gray-200 text-royal-blue-600' : 'text-gray-700 hover:bg-gray-50 hover:text-royal-blue-600', 'group flex items-center gap-x-2 rounded-md p-2 text-sm/6 font-semibold']">
<!--                                    <component :is="tab.icon" :class="[tab.current ? 'text-indigo-600' : 'text-gray-400 group-hover:text-indigo-600', 'size-6 shrink-0']" aria-hidden="true" />-->
                                    <img :src="tab.icon" :alt="tab.name" :class="[tab.current ? 'text-royal-blue-600' : 'text-gray-400 group-hover:text-royal-blue-600', 'size-5 shrink-0']" aria-hidden="true" />
                                    {{ tab.name }}
                                    <span v-if="tab.count" class="ml-auto w-9 min-w-max rounded-full bg-white px-2.5 py-0.5 text-center text-xs/5 font-medium whitespace-nowrap text-gray-600 ring-1 ring-gray-200 ring-inset" aria-hidden="true">{{ tab.count }}</span>
                                </router-link>
                                <a :href="tab.href" v-if="tab.external && !tab.actionable" target="_blank" :class="['text-gray-700 hover:bg-gray-50 hover:text-royal-blue-600', 'group flex items-center gap-x-2 rounded-md p-2 text-sm/6 font-semibold']">
                                    <img :src="tab.icon" :alt="tab.name" :class="[tab.current ? 'text-royal-blue-600' : 'text-gray-400 group-hover:text-royal-blue-600', 'size-5 shrink-0']" aria-hidden="true" />
                                    {{ tab.name }}
                                </a>
                                <a href="#" @click.prevent="tab.action" v-if="tab.external && tab.actionable" :class="['text-gray-700 hover:bg-gray-50 hover:text-royal-blue-600', 'group flex items-center gap-x-2 rounded-md p-2 text-sm/6 font-semibold']">
                                    <img :src="tab.icon" :alt="tab.name" :class="[tab.current ? 'text-royal-blue-600' : 'text-gray-400 group-hover:text-royal-blue-600', 'size-5 shrink-0']" aria-hidden="true" />
                                    {{ tab.name }}
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="hidden sm:block">
                    <nav class="-mb-px flex space-x-4 overflow-x-auto lg:overflow-x-hidden">
                        <template v-for="tab in tabs" :key="tab.name" >
                            <router-link v-if="!tab.external" :to="tab.href" :class="[tab.current ? 'border-blue-600 text-blue-700' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700', 'border-b-2 px-1 pb-4 text-sm font-medium whitespace-nowrap flex items-center gap-1.5']" :aria-current="tab.current ? 'page' : undefined">
                                <img :src="tab.icon" :alt="tab.name" :class="[tab.current ? 'text-royal-blue-600' : 'text-gray-400 group-hover:text-royal-blue-600', 'size-5 shrink-0']" aria-hidden="true" />
                                {{ tab.name }}
                                <span v-if="tab.count" :class="[tab.current ? 'bg-blue-100 text-royal-blue-500' : 'bg-gray-200 text-gray-900', 'ml-3 hidden rounded-full px-2.5 py-0.5 text-xs font-medium md:inline-block']">{{ tab.count }}</span>
                            </router-link>
                            <a :href="tab.href" v-if="tab.external && !tab.actionable" target="_blank" :class="['border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700', 'border-b-2 px-1 pb-4 text-sm font-medium whitespace-nowrap flex items-center gap-1.5']">
                                <img :src="tab.icon" :alt="tab.name" :class="[tab.current ? 'text-royal-blue-600' : 'text-gray-400 group-hover:text-royal-blue-600', 'size-5 shrink-0']" aria-hidden="true" />
                                {{ tab.name }}
                            </a>
                            <a href="#" @click.prevent="tab.action" v-if="tab.external && tab.actionable" :class="['border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700', 'border-b-2 px-1 pb-4 text-sm font-medium whitespace-nowrap flex items-center gap-1.5']">
                                <img :src="tab.icon" :alt="tab.name" :class="[tab.current ? 'text-royal-blue-600' : 'text-gray-400 group-hover:text-royal-blue-600', 'size-5 shrink-0']" aria-hidden="true" />
                            </a>
                        </template>
                        <router-link to="/subscription" v-if="isCurrentGallery" :class="['border-transparent text-blue-700 hover:border-gray-300 hover:text-blue-600', 'ml-auto border-b-2 px-1 pb-4 text-sm font-medium whitespace-nowrap']">
                            <span>{{ gallery.photos_count }} {{ $t('files_controls_menu.files_count') }} <strong class="ms-2">{{ storageUsed }}</strong></span>
                        </router-link>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

import {mapActions, mapGetters} from "vuex";
import {formatStorage} from "@/_helpers/formatters";
import ShareGalleryModalComponent from "@/components/Galleries/Modals/ShareGalleryModalComponent.vue";
// import {ChevronDownIcon} from "@heroicons/vue/16/solid";

interface NavTab {
    name: string;
    href: string | null;
    count: number;
    current: boolean;
    external: boolean,
    action: (() => void) | null;
    actionable: boolean,
    icon: string;
}

export default defineComponent({
    name: "ControlsMenuComponent",
    components: {ShareGalleryModalComponent},
    // components: {ChevronDownIcon},

    data() {
        return {
            activeTab: "settings",
            showShareModal: false,
        };
    },

    computed: {
        ...mapGetters({
            gallery: 'galleries/gallery',
            currentUser: 'user/user',
        }),

        currentSection(): string {
            return this.$route.name as string;
        },

        currentSlug(): string {
            return this.$route.params.gallery as string;
        },

        isCurrentGallery(): boolean {
            return this.gallery != null && this.gallery.slug == this.currentSlug;
        },

        storageUsed(): string {
            return formatStorage(parseInt(this.gallery.storage_used), this.$t);
        },

        tabs(): NavTab[] {
            if(!this.gallery) {
                return [];
            }

            const tabs = [
                {
                    name: this.$t('files_controls_menu.files'),
                    href: `/galleries/${this.gallery.slug}/photos`,
                    count: this.gallery.photos_count,
                    action: () => {},
                    actionable: false,
                    external: false,
                    current: this.currentSection == "galleries.photos",
                    icon: require('@/assets/images/icons/emoji-film.png'),
                },
            ];

            if(this.gallery.allow_favorite) {
                tabs.push({
                    name: this.$t('files_controls_menu.favorites'),
                    href: `/galleries/${this.gallery.slug}/favorites`,
                    count: this.gallery.favorites_count,
                    action: () => {},
                    actionable: false,
                    external: false,
                    current: this.currentSection == "galleries.favorites",
                    icon: require('@/assets/images/icons/emoji-red-heart.png'),
                });

            }

            tabs.push(
                {
                    name: this.$t('files_controls_menu.settings'),
                    href: `/galleries/${this.gallery.slug}/settings`,
                    count: 0,
                    action: () => {},
                    actionable: false,
                    external: false,
                    current: this.currentSection == "galleries.settings",
                    icon: require('@/assets/images/icons/emoji-gear.png'),
                },
                {
                    name: this.$t('files_controls_menu.design'),
                    href: `/galleries/${this.gallery.slug}/design`,
                    count: 0,
                    action: () => {},
                    actionable: false,
                    external: false,
                    current: this.currentSection == 'galleries.design',
                    icon: require('@/assets/images/icons/emoji-art.png'),
                },
                {
                    name: this.$t('files_controls_menu.view'),
                    href: this.gallery.public_url_with_token,
                    count: 0,
                    action: () => {},
                    actionable: false,
                    current: false,
                    external: true,
                    icon: require('@/assets/images/icons/emoji-eyes.png'),
                },
                {
                    name: this.$t('files_controls_menu.share'),
                    href: '#shareModal',
                    count: 0,
                    action: () => { this.showShareModal = true; },
                    actionable: true,
                    current: false,
                    external: true,
                    icon: require('@/assets/images/icons/emoji-loudspeaker.png'),
                },
            );

            return tabs;
        }
    },

    mounted() {
        //
    },

    methods: {
        ...mapActions({
            "success": "alerts/success",
        }),

        publicUrl(url: string): string {
            return process.env.VUE_APP_PUBLIC_URL + url;
        },

        copyUrl() {
            navigator.clipboard.writeText(this.gallery.public_url);

            this.success({
                message: this.$t('files_controls_menu.link_copied'),
            });
        }
    }
})
</script>

<style lang="scss" scoped>
.sidebar-skeleton-loader {
    @keyframes loading {
        0% {
            background-position: 200% 0;
        }
        100% {
            background-position: -200% 0;
        }
    }

    .skeleton {
        background: linear-gradient(90deg, #e0e0e0, #f1f3f9, #e0e0e0);
        background-size: 400% 100%;
        animation: loading 4s infinite linear;
        border-radius: 4px;
        display: inline-block;

        &-text {
            height: 16px;
            width: 60px;
            margin-bottom: 0.5rem;
        }
        &-number {
            height: 16px;
            width: 60px;
            margin-left: 8px;
        }
    }
}

.modal-content {
    border-radius: 10px;
}
</style>